import React from "react";
import { Typewriter } from "react-simple-typewriter";
import { Link } from "react-scroll";
import SocialHandles from "./SocialHandles";
import ProfileData from "../data/profile";
import Wave from "./Wave";

const Profile = () => {
  return (
    <section id="home" className="relative text-gray-600 bg-darkblue body-font pt-20 min-h-[calc(100vh-4mm)]">
      <div className="p-5 mx-auto gap-2 flex flex-col md:pt-12 md:px-7 lg:py-20 lg:flex-row-reverse items-center min-h-fit">
        <div
          data-aos="zoom-in-up"
          data-aos-duration="1000"
          className="w-5/6 sm:max-w-xs md:max-w-sm lg:max-w-md sm:w-2/6 lg:mr-10 xl:mr-20 lg:p-5 lg:w-1/3 xl:w-1/4"
        >
          <img
            className="object-cover object-center bg-gray-200 border-2 border-white pointer-events-none rounded-full shadow-2xl"
            alt={ProfileData.name}
            src={ProfileData.img}
          />
        </div>
        <div className="lg:flex-grow lg:pr-4 lg:mr-14 flex flex-col md:mb-0 items-center text-center xl:scale-105">
          <SocialHandles />
          <h2 className="title-font md:text-3xl text-2xl mb-4 text-center font-medium text-white">
            Hello, I am <span className="text-dark-orange">{ProfileData.name}</span>
          </h2>
          <div className="text-3xl text-white mb-4 font-medium lg:inline-block h-12">
            &nbsp;
            <Typewriter
              words={ProfileData.professions}
              loop={0}
              cursor
              cursorStyle="_"
              typeSpeed={140}
              deleteSpeed={90}
              delaySpeed={1500}
            />
          </div>
          {ProfileData.info?.map((item, index) => (
                <p key={index} className="mb-2 text-white text-sm md:text-base leading-relaxed max-w-lg mx-auto">
                {item}
            </p>
          ))}
          <div className="mt-4 flex gap-x-4 md:gap-x-5 justify-center">
            <button className="inline-flex font-medium text-white bg-black border-2 border-white py-3 px-7 hover:bg-white hover:text-black transition-all duration-300 rounded-full text-md shadow-lg">
              <Link to="contact" spy={true} smooth={true} offset={-100} duration={750}>
                Contact Me
              </Link>
            </button>
            
            {/* Direct Download Link */}
            <a 
              href={ProfileData.resume} 
              download="Om_Bhaltilak_Resume.pdf"
            >
              <button className="inline-flex font-medium text-white bg-dark-orange border-2 border-dark-orange py-3 px-7 hover:bg-white hover:text-dark-orange transition-all duration-300 rounded-full text-md shadow-lg">
                Get Resume
              </button>
            </a>
          </div>
        </div>
      </div>
      <Wave />
    </section>
  );
};

export default Profile;